import React from "react";
import { Form } from "react-bootstrap";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { storageKeys } from "../../../constants/storageKeys";
import initialSettings from "../../../constants/settings.json";

const InstructionsSettings = () => {
  const [userInstructions, setUserInstructions] = useLocalStorage(
    storageKeys.LLM_USER_INSTRUCTIONS,
    JSON.parse(initialSettings.localStorage.LLM_USER_INSTRUCTIONS)
  );
  const [systemInstructions, setSystemInstructions] = useLocalStorage(
    storageKeys.LLM_SYSTEM_INSTRUCTIONS,
    JSON.parse(initialSettings.localStorage.LLM_SYSTEM_INSTRUCTIONS)
  );

  return (
    <>
      <Form.Group className="mb-4">
        <Form.Label>System Instructions</Form.Label>
        <Form.Control
          as="textarea"
          rows={10}
          value={systemInstructions}
          onChange={(e) => setSystemInstructions(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-4">
        <Form.Label>User Instructions</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          value={userInstructions}
          onChange={(e) => setUserInstructions(e.target.value)}
        />
      </Form.Group>
    </>
  );
};

export default InstructionsSettings;
